import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
// import { getAllCategories } from '../api/Categories';
// import { Category } from '../models/Category';
// import { Franchise } from '../models/Franchise';
// import { getAllFranchises } from '../api/Franchises';

export const GlobalContext = createContext<any>(null);

export const GlobalDataProvider = ({ children }: { children: React.ReactNode }) => {
  const [paymentMetod, setPaymentMetod] = useState<string[]>(['paypal', 'binance', 'zelle', 'pago movil', 'divisas']);
  const [entregatMetod, setEntregaMetod] = useState<string[]>(['delivery', 'pickup', 'envio']);
  const [statusOrder, setStatusOrder] = useState<string[]>(['paypal', 'binance', 'zelle', 'pago movil', 'divisas']);

//   const [categories, setCategories] = useState<Category[]>([]);
//   const [franchises, setFranchises] = useState<Franchise[]>([]);
  const [loading, setLoading] = useState(true);

//   const fetchData = async () => {
//     try {
//       const [catRes, franRes] = await Promise.all([
//         getAllCategories(),
//         getAllFranchises()
//       ]);
//       setCategories(catRes);
//       setFranchises(franRes);
//     } catch (error) {
//       console.error("Error cargando datos globales", error);
//     } finally {
//       setLoading(false);
//     }
//   };

  useEffect(() => {
    // fetchData();
  }, []);

  return (
    // <GlobalContext.Provider value={{ categories, franchises, loading, refreshData: fetchData }}>
    <GlobalContext.Provider value={{ paymentMetod, entregatMetod ,loading}}>

      {children}
    </GlobalContext.Provider>
  );
};